import { CrfVersion } from './CrfVersion';
import type {
  CommentOrdering,
  NarrativeLayout,
  WorkspaceVariant,
} from './types';

export class LegacyCrf extends CrfVersion {
  readonly code = '';

  get workspaceVariant(): WorkspaceVariant {
    return 'legacy';
  }

  get narrativeLayout(): NarrativeLayout {
    return 'main-extra';
  }

  get commentOrdering(): CommentOrdering {
    return 'linked-unlinked';
  }

  get viewCommentsLabel(): string {
    return 'View narrative and comments';
  }
}
